import { Outlet, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../lib/auth';
import { LanguageSelector } from './LanguageSelector';

export function Layout() {
  const { user, isAdmin, logout } = useAuth();
  const { t } = useTranslation();

  const isNonProd = !window.location.hostname.startsWith('artifact.compliance.amazon');

  return (
    <div className="app-layout">
      {isNonProd && (
        <div className="env-banner">
          NON-PRODUCTION ENVIRONMENT — For testing only
        </div>
      )}
      <header className="app-header">
        <div className="header-brand">
          <h1>{t('layout.title')}</h1>
        </div>
        <nav className="header-nav">
          <Link to="/reports">{t('layout.reports')}</Link>
          {isAdmin && <Link to="/admin">{t('layout.admin')}</Link>}
        </nav>
        <div className="header-user">
          <LanguageSelector />
          <span>{user?.email}</span>
          <button onClick={logout} className="btn-logout">
            {t('layout.signOut')}
          </button>
        </div>
      </header>
      <main className="app-main">
        <Outlet />
      </main>
      <footer className="app-footer">
        <p>{t('common.pciConfidential')}</p>
        <p>
          <a href="mailto:pci-contact@amazon.com">pci-contact@amazon.com</a>
        </p>
      </footer>
    </div>
  );
}
